import React from 'react';

const LocationIcon = () => {
    return (
        <svg id="pin" xmlns="http://www.w3.org/2000/svg" width="17.41" height="21.729" viewBox="0 0 17.41 21.729">
            <g id="Group_2184" data-name="Group 2184" transform="translate(4.671 4.671)">
                <g id="Group_2183" data-name="Group 2183">
                    <path id="Path_3602" data-name="Path 3602" d="M164.981,110.062a4.034,4.034,0,1,0,4.034,4.034A4.039,4.039,0,0,0,164.981,110.062Zm0,6.369a2.335,2.335,0,1,1,2.335-2.335A2.338,2.338,0,0,1,164.981,116.431Z" transform="translate(-160.947 -110.062)" fill="#699c47" />
                </g>
            </g>
            <g id="Group_2186" data-name="Group 2186">
                <g id="Group_2185" data-name="Group 2185">
                    <path id="Path_3603" data-name="Path 3603" d="M59.59,0a8.715,8.715,0,0,0-8.7,8.7v.241c0,2.428,1.392,5.256,4.137,8.408A35.783,35.783,0,0,0,59.056,21.3l.534.431.534-.431a35.775,35.775,0,0,0,4.035-3.944c2.745-3.151,4.137-5.98,4.137-8.408V8.705A8.715,8.715,0,0,0,59.59,0ZM66.6,8.946c0,4.1-5.286,9.068-7.006,10.576-1.721-1.508-7.006-6.474-7.006-10.576V8.705a7.006,7.006,0,0,1,14.013,0Z" transform="translate(-50.885)" fill="#699c47" />
                </g>
            </g>
        </svg>
    );
};

export default LocationIcon;